import { useRef, useState } from "react";
import { ImagePlus, RefreshCw } from "lucide-react";

export const UploadZone = ({ file, preview, onFile, testId = "upload", title = "Drop your photo here", compact = false }) => {
  const input = useRef(null);
  const [over, setOver] = useState(false);
  const h = compact ? "h-40" : "h-64";

  const pick = (f) => f && onFile(f);

  return (
    <div
      data-testid={`${testId}-input-zone`}
      onClick={() => input.current?.click()}
      onDragOver={(e) => {
        e.preventDefault();
        setOver(true);
      }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => {
        e.preventDefault();
        setOver(false);
        pick(e.dataTransfer.files?.[0]);
      }}
      className={`relative cursor-pointer rounded-2xl border-2 border-dashed transition-[border-color,background-color] duration-300 overflow-hidden ${
        over ? "border-[#d5d9df] bg-[#3b4049]/10" : "border-white/15 hover:border-[#d5d9df]/60 bg-white/[0.02]"
      }`}
    >
      <input
        ref={input}
        type="file"
        accept="image/jpeg,image/png,image/webp,image/heic,image/heif"
        className="hidden"
        data-testid={`${testId}-file-input`}
        onChange={(e) => pick(e.target.files?.[0])}
      />
      {preview ? (
        <div className={`relative ${h}`}>
          <img src={preview} alt="Your upload" className="h-full w-full object-cover" />
          <div className="absolute inset-x-0 bottom-0 p-4 flex items-center justify-between bg-gradient-to-t from-black/80 to-transparent">
            <span className="text-sm truncate max-w-[70%]" data-testid={`${testId}-file-name`}>{file?.name}</span>
            <span className="text-xs flex items-center gap-1.5 text-[#e6e8ec]"><RefreshCw className="h-3.5 w-3.5" /> Replace</span>
          </div>
        </div>
      ) : (
        <div className={`${h} flex flex-col items-center justify-center gap-4 px-6 text-center`}>
          <div className="h-14 w-14 rounded-xl bg-[#3b4049]/20 ring-1 ring-[#d5d9df]/30 grid place-items-center">
            <ImagePlus className="h-6 w-6 text-[#e6e8ec]" />
          </div>
          <div>
            <div className="font-display font-semibold text-sm sm:text-base">{title}</div>
            <div className="text-sm text-slate-400 mt-1">or tap to browse · JPG, PNG, WEBP, HEIC · up to 15MB</div>
          </div>
        </div>
      )}
    </div>
  );
};
